<a href="/dashboard"><img src='../../../../assets/img/logo/mychas-light.png' alt="CHAS" /></a>
<!-- TODO consider using an SVG logo for scalability. -->
